import { useEffect, useState } from 'react';
import { RemoteParticipant, Room } from 'twilio-video';

export interface UseParticipantsOptions {
    room: Room | null;
}

export interface UseParticipantsResult {
    participants: RemoteParticipant[];
}

export default function useParticipants({ room }: UseParticipantsOptions): UseParticipantsResult {
    const [participants, setParticipants] = useState<RemoteParticipant[]>([]);

    const handleParticipantConnected = (participant: RemoteParticipant) => {
        setParticipants((_participants) => [..._participants, participant]);
    };

    const handleParticipantDisConnected = (participant: RemoteParticipant) => {
        setParticipants((_participants) => [
            ..._participants.filter((__participant) => __participant.sid !== participant.sid),
        ]);
    };

    useEffect(() => {
        if (room) {
            setParticipants([...room.participants.values()]);
            room.on('participantConnected', handleParticipantConnected);
            room.on('participantDisconnected', handleParticipantDisConnected);
        }
        return () => {
            room?.off('participantConnected', handleParticipantConnected);
            room?.off('participantDisconnected', handleParticipantDisConnected);
        };
    }, [room]);

    return { participants };
}
